/** @jsxRuntime classic */
/** @jsx jsx */
import styled from '@emotion/styled';
import { css, jsx } from '@emotion/react';
import axios from "axios";
import React, {useContext, useEffect, useState} from "react";
import {Billing} from "../components/Billing";
import {AxiosContext} from "@front-component";

const Style = styled.div`
height: 100%;
`

export function BillingSuccessPage(){
    const {api}= useContext(AxiosContext)
    const [subscription,setSubscription] = useState(undefined)
    async function load(){
        const data = await api.get("/checkout/success?session_id="+ new URLSearchParams(window.location.search).get("session_id"))
        setSubscription(data.data)
        window.location.href = "/brand-protection/monitor-competitors"
    }
    useEffect(() =>{
        load().then()
    },[])

    return <Style>
            <Billing/>
    </Style>
}

